/** @type {(href?: string) => boolean} */
export const isExternalLink = href => {
	const url = new URL(href, "http://localhost");
	return url.host !== "localhost";
};
